import map from 'lodash/map';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {v4 as uuidV4} from 'uuid';
import IconInfo from '@spothero/icons/info';
import FormGroup from '@spothero/ui/form-group';
import Label from '@spothero/ui/label';
import Radio from '@spothero/ui/radio';
import RadioGroup from '@spothero/ui/radio-group';
import TextButton from '@spothero/ui/text-button';
import DOMUtils from '@spothero/utils/dom';
import SpotUtils from 'utils/spot';

export default class MultiRateChooser extends Component {
    static propTypes = {
        rates: PropTypes.array.isRequired,
        selectedRate: PropTypes.object.isRequired,
        priceLabel: PropTypes.string,
        onMultiRateChange: PropTypes.func.isRequired,
        onInfoButtonClick: PropTypes.func,
    };

    constructor(props) {
        super(props);

        const {rates, selectedRate} = props;

        this.state = {
            rates,
            selectedRate,
            radioGroupKey: uuidV4(),
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const {rates: nextRates, selectedRate: nextSelectedRate} = nextProps;
        const {rates, selectedRate} = prevState;

        if (nextRates[0].fullRule !== rates[0].fullRule) {
            return {
                rates: nextRates,
                radioGroupKey: uuidV4(),
            };
        } else if (nextSelectedRate.fullRule !== selectedRate.fullRule) {
            return {
                radioGroupKey: uuidV4(),
            };
        }

        return null;
    }

    _onRateChange = evt => {
        this.props.onMultiRateChange(parseInt(evt.target.value, 10));
    };

    _onInfoButtonClick = evt => {
        const radioContainer = DOMUtils.parent(evt.currentTarget, '.Radio');
        const value = parseInt(
            DOMUtils.attr(radioContainer.querySelector('input'), 'value'),
            10
        );

        this.setState((prevState, props) => {
            return {
                rates: map(prevState.rates, rate => {
                    rate.checked = value === rate.fullRule;

                    return rate;
                }),
                radioGroupKey: uuidV4(),
            };
        });

        this.props.onMultiRateChange(value);
        this.props.onInfoButtonClick();
    };

    _renderTitleAndPrice({title, price}) {
        const {priceLabel} = this.props;

        return (
            <div className="ParkingOption-content">
                <span className="ParkingOption-title">
                    {title}
                    {this._renderInfoButton()}
                </span>
                <span className="ParkingOption-price-with-label">
                    <span
                        className="ParkingOption-price"
                        dangerouslySetInnerHTML={{
                            __html: price,
                        }}
                    />
                    {priceLabel && (
                        <span className="ParkingOption-price-label">
                            {priceLabel}
                        </span>
                    )}
                </span>
            </div>
        );
    }

    _renderInfoButton() {
        if (!this.props.onInfoButtonClick) {
            return null;
        }

        return (
            <TextButton onClick={this._onInfoButtonClick} iconPosition="left">
                <IconInfo />
            </TextButton>
        );
    }

    render() {
        const {selectedRate} = this.props;
        const {rates, radioGroupKey} = this.state;

        return (
            <div className="MultiRateChooser">
                <FormGroup>
                    <RadioGroup
                        key={radioGroupKey}
                        id="MultiRateChooser-available-rates"
                        className="SelectRate"
                        name="available-rates"
                        onChange={this._onRateChange}
                    >
                        {map(rates, rate => {
                            const {
                                fullRule,
                                title,
                                display_price: displayPrice,
                                currency_type: currencyType,
                            } = rate;
                            const isSelected =
                                selectedRate.fullRule === fullRule;
                            const radioClassNames = classNames([
                                'ParkingOption-multi',
                                {selected: isSelected},
                            ]);
                            const displayPriceFormatted = SpotUtils.formatRatePrice(
                                {
                                    price: displayPrice,
                                    currencyType,
                                }
                            );

                            return (
                                <Radio
                                    key={fullRule}
                                    className={radioClassNames}
                                    label={
                                        <Label>
                                            {this._renderTitleAndPrice({
                                                title,
                                                price: displayPriceFormatted,
                                            })}
                                        </Label>
                                    }
                                    value={`${fullRule}`}
                                    defaultChecked={isSelected}
                                />
                            );
                        })}
                    </RadioGroup>
                </FormGroup>
            </div>
        );
    }
}
